export default states => ({
    articleQuery: states.module.table,
    articleParams: states.module.articleParams
})